import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { pairwise } from 'rxjs/operators';

@Component({
  selector: 'app-advance-create-step',
  templateUrl: './advance-create-step.component.html',
  styleUrls: ['./advance-create-step.component.sass']
})
export class AdvanceCreateStepComponent implements OnInit {

  constructor() { }

  @Input()
  advanceForm: FormGroup = new FormGroup({
    amount: new FormControl(0, [Validators.required, Validators.min(1)]),
    observations: new FormControl(undefined, [Validators.required])
  })

  @Output()
  getAdvance: EventEmitter<number> = new EventEmitter();
  ngOnInit(): void {
    this.advanceForm.valueChanges.pipe(pairwise()).subscribe(async ([prev, next]) => {
      if (next.amount) {
        this.getAdvance.emit(next.amount);
      }
    })
  }

}
